// @ts-nocheck
// TODO: tighten types after migration
import React from "react";
import SocialLinks from "./SocialLinks";

export default function FollowMeOn() {
    return (
        <div className="follow-me-on-container follow-me-section m-0 mb-5 w-full p-5 pl-[15px] rounded-lg sm:my-[2%] sm:py-[15px] md:my-[2%] md:py-[18px] md:px-[18px] lg:my-[2%] lg:py-[18px] lg:px-[18px]">
            <h3 className="text-post-heading font-serif font-bold text-[1.5em] m-0 mb-[15px] text-left sm:text-[1.2em] md:text-[1.25em] lg:text-[1.3em] xl:text-[1.5em]">Follow me on</h3>
            <SocialLinks className="m-0 pl-0" noShadow />
        </div>
    );
}

